<template>
  <div>
    联系我们
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {

    }
  }
}
</script>

</style>



// WEBPACK FOOTER //
// src/components/contactUs.vue